import { createAction, props } from '@ngrx/store';

export const openEsgFocusDrawer = createAction(
  '[Common Esg] Open Esg Focus Drawer',
  props<{
    payload: {
      id?: { prId?: number | null; crmId?: number | null };
      type: string;
      name: string | null;
    };
  }>()
);
